import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

type ConfirmationsParams = {
  marketPlace: string;
  pricingProductId?: number;
  planId?: number;
  date?: string;
  priceDiff?: "INCREASE" | "DECREASE" | "SAME";
  priceMismatch?: boolean;
  limit?: number;
};

export const useConfirmations = (params: ConfirmationsParams, options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: [{ entity: "pricing_confirmations", params }],
    queryFn: async () =>
      await apiClient.getConfirmations({
        queries: {
          market_place: params.marketPlace,
          pricing_product: params.pricingProductId,
          plan: params.planId,
          date: params.date,
          price_diff: params.priceDiff,
          price_mismatch: params.priceMismatch,
          limit: params.limit,
          ordering: "-date",
        },
      }),
    select: (data) => data.results,
    ...options,
  });
};
